export default __webpack_public_path__ + "static/media/naga.06462765.jpg";